import { Component, signal } from '@angular/core';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { LangPipe } from '@library/utils/pipes/lang.pipe';
import { EnergyReportsFacade } from '@store/energy-reports/energy-reports.facade';
import { EnergyReport } from '@store/energy-reports/energy-reports.interface';
import { getMonthText } from '../../control-page-reports.service';

@Component({
  selector: 'app-cp-reports-energy-savings-card',
  templateUrl: './cp-reports-energy-savings-card.component.html',
  styleUrls: ['./cp-reports-energy-savings-card.component.scss']
})
export class CpReportsEnergySavingsCardComponent {

  report$ = this.energyReportsFacade.currentReport$.pipe(isDefined());

  isInfoOpen = signal(false);

  getMonthText = getMonthText;

  constructor(
    private energyReportsFacade: EnergyReportsFacade,
    private langPipe: LangPipe,
  ) {

  }

  displaySavingsExplanations(report: EnergyReport) {
    if (!report.saving_in_percentage_using_schedule
       || !report.saving_in_percentage_using_away_mode
       || !report.saving_in_percentage_using_manual_mode
    ) {
      return false;
    }
    return true;
  }

  savingInMoneySmaller(report: EnergyReport) {
    let savings_in_money_smaller = false;
    if ((report.savings_low_range + '-' + report.savings_high_range).length > 7)
      savings_in_money_smaller = true;
    return savings_in_money_smaller;
  }

  getSavingSentence(report: EnergyReport) {
    if (report.savings_high_range != undefined
      && report.savings_low_range != undefined
      && report.savings_currency != undefined) {
      return this.langPipe.transform('bilan-energy.__SAVINGS_EURO_MIN_MAX',
        [report.savings_low_range.toString(), report.savings_high_range.toString() + report.savings_currency]);

    }
  }
  getSaving(report: EnergyReport) {
    if(report.savings_high_range != undefined
        && report.savings_low_range != undefined
        && report.savings_currency != undefined) {
      return report.savings_low_range + '-' + report.savings_high_range + report.savings_currency;
    }
    else {
      return null;
    }
  }

  setInfo() {
    this.isInfoOpen.update(isOpen => !isOpen);
  }
}